export type TStatsCounter = {
  chars: number;
  words: number;
};

export interface IStatsState {
  isLoading: boolean;
  counters: Record<string, TStatsCounter>;
}

export interface ICountForNoteAction {
  noteId: string;
  content: string;
}

export interface ICountForProjectAction {
  list: {
    id: string;
    content: string;
  }[];
}

export const STATS_COUNT_FOR_NOTE = 'STATS_COUNT_FOR_NOTE';
export const STATS_COUNT_FOR_PROJECT = 'STATS_COUNT_FOR_PROJECT';

export interface IUpdateCounterAction {
  id: string;
  counter: TStatsCounter;
}

export const STATS_UPDATE_COUNTER = 'STATS_UPDATE_COUNTER';

export interface IUpdateAllCountersAction {
  dict: Record<string, TStatsCounter> | null;
}

export const STATS_UPDATE_ALL_COUNTERS = 'STATS_UPDATE_ALL_COUNTERS';
